import { configureStore } from '@reduxjs/toolkit';
import rootReducer from './reducers/index'; // Import the combined reducer from the previous step

const store = configureStore({
  reducer: rootReducer,
  devTools: false,
});

export default store;
